/**
 * Returns true when value is undefined, null, '' or an empty object or array.
 * @return {boolean}
 */
const isEmpty = value => {
  return !value || !Object.keys(value).length;
};
/**
 * Returns true when value is an object.
 * @return {boolean}
 */
const isObject = value => !!value && typeof value === 'object';
/**
 * Returns true when value is a string.
 * @return {boolean}
 */
const isString = value => typeof value === 'string';
/**
 * Empty method to prevent null method invoke.
 */
// eslint-disable-next-line unused-imports/no-unused-vars-ts, @typescript-eslint/no-empty-function
const noop = function () {
  // noop
};
export { isEmpty, isObject, isString, noop };